<div mat-dialog-title>
  <span>{{'stations.configuredGraphs.modal.modalReferenceLine.title' | translate}}</span>
</div>
<div class="badge__ctn">
  <mat-dialog-content>
    <!-- Badge assignment -->
    <form [formGroup]="detailForm" (keydown.enter)="$event.preventDefault()">
      <div class="form-group w-100 mb-10">
        <label for="name" class="required">{{'stations.configuredGraphs.modal.modalReferenceLine.name' | translate}}</label>
        <input class="form-control" formControlName="name" id="name">
      </div>
      <div class="form-group w-100 mb-10">
        <label for="value" class="required">{{'stations.configuredGraphs.modal.modalReferenceLine.value' | translate}}</label>
        <input type="value"  class="form-control" formControlName="value" id="value">
      </div>
      <div class="form-group w-100 mb-10">
        <label for="color">{{'stations.configuredGraphs.modal.modalColor.color' | translate}}</label>
        <input type="color"  class="form-control" formControlName="color" id="color">
      </div>

      <div class="form-group w-100 mb-10">
        <label for="number">{{'stations.configuredGraphs.modal.modalColor.width' | translate}}</label>
        <input type="number"  class="form-control" formControlName="width" id="width">
      </div>
      <div class="form-group w-100 mb-10">
        <label for="number">{{'stations.configuredGraphs.modal.modalColor.type' | translate}}</label>
        <select name="" title="type" formControlName="type" class="form-control" id="type" placeholder="type">
          @for (lineType of LineTypes; track lineType) {
            <option [ngValue]="lineType"
              class="text-capitalize">
              {{ "stations.configuredGraphs.lineType." + lineType | translate}}
            </option>
          }
        </select>
      </div>
      <div class="form-group">
        <label for="yAxisIndex" class="required">{{'stations.configuredGraphs.modal.modalColor.name' | translate}}</label>
        <select name="" title="yAxis" formControlName="yAxisIndex" class="form-control" id="yAxisIndex" placeholder="yAxisIndex">
          @for (yAxi of yAxis; track yAxi) {
            <option [ngValue]="yAxi.index"
              class="text-capitalize">
              {{ yAxi.name}}
            </option>
          }
        </select>
      </div>
    </form>
  </mat-dialog-content>
  <div mat-dialog-actions>
    <button class="btn btn--primary" type="submit" (click)="onSubmit()">{{'action.submit' | translate}}</button>
    <button mat-dialog-close
      class="btn btn--outline-grey-color ml-20">{{'action.cancel' | translate}}
    </button>
  </div>
</div>